
<app-scotty-card [title]="'Plants' | translate" hideDivisor="true" [actions]="getActions()">

  <ng-container *ngIf="!isLoading; else loading">
    <app-list-view-element *ngFor="let fieldService of fieldServicesToShow"
                           [icon]="fieldService['icon']"
                           [title]="fieldService['name']"
                           [subtitle]="fieldService['description'] || 'No description provided'"
                           [chips]="fieldService['address']"
                           (click)="router.navigate(['field-service', fieldService['uid']])"
    ></app-list-view-element>
    <p *ngIf="fieldServicesToShow.length == 0" class="info">{{ 'No field service found' | translate }}</p>
  </ng-container>

  <mat-paginator
    [hidePageSize]="true"
    [pageSize]="paginator.pageSize"
    [pageIndex]="paginator.currentPage"
    [length]="paginator.totalElements"
    (page)="paginator.pageChanged($event)"
    showFirstLastButtons>
  </mat-paginator>

</app-scotty-card>

<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
